<template>
    <div class="page-scroller-tabs">
        <div class="btn-group">
            <button v-for="(name, idx) in tabs"
                    :class="idx === selected ? 'btn-primary' : 'btn-light'"
                    @click.prevent.stop="selected = idx"
                    type="button"
                    class="btn btn-sm">
                {{ typeof name === 'object' ? name.name : name }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "PageScrollerTabs",
    props: {
        tabs: {
            type: [Object, Array],
            default(){
                return [
                    'Section 01',
                    'Section 02',
                ]
            }
        },
    },

    data(){
        return {
            selected: -1,
        }
    },

    watch: {
        selected(value){
            this.$emit('change', value);
        }
    },

    mounted() {
        if( Array.isArray( this.tabs ) ){
            this.selected = this.tabs.length > 0 ? 0 : -1;
        }else{
            const keys = Object.keys( this.tabs );
            this.selected = keys.length > 0 ? keys[0] : -1
        }
    }

}
</script>

<style lang="scss" scoped>
.btn-group{
    .btn{
        border-top: $dark solid 1px;
        border-bottom: $dark solid 1px;


        &:first-child{
            border-radius: 60px 0 0 60px;
            border-left: $dark solid 1px;
        }

        &:last-child{
            border-radius: 0 60px 60px 0;
            border-right: $dark solid 1px;
        }
    }
}
</style>
